import React, { useEffect } from "react";
import { Controller } from "react-hook-form";
import { DateRange } from "react-date-range";
import {
  AppInputWrapper,
  ErrorLabel,
  InputLabel,
} from "./AppSelectDropdown/AppSelectDropdown.styles";
import DropDownTab from "./DropDownTab";
import "react-date-range/dist/styles.css";
import "@src/assets/css/DateRangePicker.styles.css";
import { theme } from "@src/theme";
import { UIButton } from "./UIButton";
import useDropDownTab from "./DropDownTab/useDropDownTab";

interface DateRangePickerProps {
  label: string;
  name: string;
  control: any;
  errors: any;
  disabled?: boolean;
  icon?: React.ReactNode;
  iconRight?: React.ReactNode;
  successStyle?: boolean;
  onDateChange: (date: any) => void;
  value?: any;
}

const defaultSelection = {
  startDate: new Date(),
  endDate: new Date(),
  key: "selection",
};
const DateRangePicker: React.FC<DateRangePickerProps> = ({
  value,
  onDateChange,
  label,
  name,
  control,
  errors,
  icon,
  iconRight,
  successStyle,
}) => {
  const [tabTitle, setTabTitle] = React.useState<string>();
  const [selectedRange, setSelectedRange] =
    React.useState<any>(defaultSelection);
  const handleSelect = (rangesByKey: any) => {
    const { selection } = rangesByKey;
    setSelectedRange(selection);
    onDateChange?.(selection);
    if (selection.startDate === selection.endDate) {
      setTabTitle(selection.startDate.toDateString());
    } else {
      setTabTitle(
        `${selection.startDate.toDateString()} - ${selection.endDate.toDateString()}`
      );
    }
  };
  const { closeDropdown, isOpen, toggleDropdown, openDropdown } =
    useDropDownTab();

  const isEmptyValue =
    !value ||
    (!value.startDate && !value.endDate) ||
    (value.startDate === undefined && value.endDate === undefined);

  useEffect(() => {
    if (isEmptyValue) {
      setSelectedRange(defaultSelection);
      setTabTitle("Date Range");
    }
  }, [value, isEmptyValue]);
  return (
    <div style={{ marginBottom: "1rem", width: "100%", minHeight: 100 }}>
      <InputLabel htmlFor={name}>{label}</InputLabel>
      <AppInputWrapper
        $success={successStyle}
        $leftIcon={!!icon}
        $iconRight={!!iconRight}
      >
        {icon && <span className="input-icon">{icon}</span>}
        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <DropDownTab
              secondaryTitleComponent={iconRight}
              isOpen={isOpen}
              toggleDropdown={toggleDropdown}
              closeDropdown={closeDropdown}
              openDropdown={openDropdown}
              titleStyles={{
                color: field.value ? theme.colors.white : theme.colors.gray,
              }}
              title={tabTitle ? tabTitle : "Date Range"}
            >
              <DateRange
                rangeColors={[theme.colors.yellow]}
                ranges={[selectedRange]}
                onChange={handleSelect}
              />
              <UIButton onClick={closeDropdown}>Apply</UIButton>
            </DropDownTab>
          )}
        />
      </AppInputWrapper>
      {errors[name] && (
        <ErrorLabel className="error-message">
          {errors[name]?.message}
        </ErrorLabel>
      )}
    </div>
  );
};

export default DateRangePicker;
